import React, { Fragment } from "react";
import { GPS_DECIMAL_PLACES } from "../../../../config/constants";
import { limitDecimalPlacesIfExceed } from "../../../../utils/numberUtils";

export const ONR_CwrRailLayingAndDistressingRecordSchema = {
  sections: [
    {
      heights: {
        header1: "auto",
      },
      minDataRowsCount: 10,
      columns: [
        {
          title: "Mileage",
          colSpan: 1,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "milla",
        },
        {
          title: "E or W Side",
          colSpan: 1,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "ewside",
        },
        {
          title: "Date",
          colSpan: 2,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "date",
        },
        {
          title: "String No.",
          colSpan: 1,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "stno",
        },
        {
          title: "Rail Weight",
          colSpan: 1,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "rweigh",
        },
        {
          title: "Manufacturer",
          colSpan: 2,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "manu",
        },
        {
          title: "Year",
          colSpan: 1,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "year",
        },
        {
          title: "Actual Rail Temp.",
          colSpan: 1,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "artemp",
        },
        {
          title: "GPS Location",
          colSpan: 3,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: ["id_lat", "id_long"],
          dontJoinValues: true,
          formatter: (values) => {
            return values
              .filter((val) => val)
              .filter((val) => val !== "")
              .filter((val) => !isNaN(parseFloat(val)))
              .map((val, index, arr) => (
                <Fragment>
                  <span>{limitDecimalPlacesIfExceed(val, GPS_DECIMAL_PLACES)}</span>
                  {index !== arr.length - 1 ? <span>{","}&nbsp;&nbsp;&nbsp;</span> : null}
                </Fragment>
              ));
          },
        },
        {
          title: "Remarks",
          colSpan: 3,
          rowSpan: 1,
          className: "tbl-text-normal",
          accessor: "com",
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/Reports/ONR/CwrRailLayingAndDistressingRecord/ONR_CwrRailLayingAndDistressingRecordSchema.js